import { useEffect, useState } from "react";
import {
  Datagrid,
  DateField,
  Filter,
  List,
  NumberField,
  type RaRecord,
  SelectInput,
  TextField,
  TextInput,
  useGetList,
} from "react-admin";
import dataProvider from "../dataProvider/dataProvider";
import { dateTimeOptionsDeCH, type Props2String } from "./Common";
import { MissionInfoStatusDatagrid } from "./MissionInfoStatus";
import { RescueVehiclesResource } from "./RescueVehicles";

export const MissionStatusResource = "missionstatus";

export const MissionStatusList = () => {
  const { data: rescueVehicles } = useGetList(RescueVehiclesResource, {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "id", order: "ASC" },
    filter: {},
  });

  const rescueVehicleChoices =
    rescueVehicles?.map((rv) => ({
      id: rv.id,
      name: rv.name,
    })) || [];

  return (
    <>
      <List
        perPage={25}
        sort={{ field: "startedAt", order: "DESC" }}
        empty={false}
        exporter={false}
        actions={false}
        filters={
          <Filter>
            <TextInput
              type="text"
              label="Suchen"
              source="query"
              alwaysOn
              resettable
            />
            <SelectInput
              source="rescueVehicleId"
              choices={rescueVehicleChoices}
              alwaysOn
              label="Einsatzmittel"
              resettable
            />
          </Filter>
        }
      >
        <Datagrid
          bulkActionButtons={false}
          rowStyle={() => ({ height: "2.25rem" })}
          rowClick={"show"}
        >
          <DateField
            source={MissionStatusProps.startedAt}
            showTime
            locales="de-CH"
            options={dateTimeOptionsDeCH}
          />
          <NumberField source={MissionStatusProps.rescueVehicleName} />
          <TextField source={MissionStatusProps.title} />
          <TextField source={MissionStatusProps.elsEventId} />
          <TextField source={MissionStatusProps.elsDispatchId} />
        </Datagrid>
      </List>
    </>
  );
};

export const MissionStatusShow = () => {
  const match = window.location.hash.match(/\/missionstatus\/(\d+)\/show/);
  const missionId = match ? match[1] : null;
  const [missionInfo, setMissionInfo] = useState<MissionStatus>();

  useEffect(() => {
    if (!missionId) return;
    dataProvider
      .getList("missionstatus", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "startedAt", order: "DESC" },
        filter: {},
      })
      .then(({ data }) => {
        const mission = data.find((m) => m.id === Number.parseInt(missionId));
        setMissionInfo(mission);
      });
  }, [missionId]);

  return (
    <>
      {missionInfo && (
        <h1 style={{ marginBottom: "-2rem" }}>
          {`${missionInfo?.rescueVehicleName}, ${missionInfo?.title}, ${missionInfo?.elsEventId}, ${missionInfo?.elsDispatchId} `}
        </h1>
      )}
      <List
        exporter={false}
        resource="missionstatus"
        filter={{ missionId }}
        empty={false}
      >
        <MissionInfoStatusDatagrid />
      </List>
    </>
  );
};

const MissionStatusProps: Props2String<MissionStatus> = {
  id: "id",
  rescueVehicleId: "rescueVehicleId",
  rescueVehicleName: "rescueVehicleName",
  startedAt: "startedAt",
  finishedAt: "finishedAt",
  elsDispatchId: "elsDispatchId",
  elsEventId: "elsEventId",
  isAcknowledged: "isAcknowledged",
  acknowledgedAt: "acknowledgedAt",
  initialNotificationType: "initialNotificationType",
  title: "title",
};

type MissionStatus = RaRecord & {
  id: number;
  rescueVehicleId: number;
  rescueVehicleName: string;
  startedAt: number;
  finishedAt: number;
  elsDispatchId: string;
  elsEventId: string;
  initialNotificationType: MissionNotificationType;
  title: string;
  acknowledgedAt: number;
  isAcknowledged: boolean;
};

export type MissionNotificationType = "INFO" | "ALARM";

export const notificationTypeChoices: {
  id: MissionNotificationType;
  name: MissionNotificationType;
}[] = [
  { id: "INFO", name: "INFO" },
  { id: "ALARM", name: "ALARM" },
];
